import { useAppContext } from '../../state/AppContext'
import { ProductTile } from '../AutoGenerate/types/ProductTile'
import { ProductTileV2 } from '../ProductTileV2'

interface ProductGridLaneErrorProps {
  tile: ProductTile
  index: number
  productGridLayout?: 'horizontal' | 'vertical'
  hideProductDescription?: boolean
  colorSwatchCount: number
}

export const ProductLaneError = ({
  tile,
  index,
  productGridLayout,
  hideProductDescription,
  colorSwatchCount
}: ProductGridLaneErrorProps) => {
  return (
    <>
      <ProductTileV2
        name={tile.name ?? ''}
        description={!hideProductDescription ? (tile.description ?? '') : ''}
        image={tile.image}
        linkUrl={tile.linkUrl}
        callout={{ value: "Unavailable (Won't show in prod)", skin: 'holiday', variant: 'inverse' }}
        layout={productGridLayout || 'vertical'}
        disabled
        index={index + 1}
        pageZone=""
        mpvId={tile.mpvId}
        productId={tile.productId}
        showPrice={!!tile.showPrice}
        enableCampaignCallouts={tile?.enableCampaignCallouts || false}
        colorInformation={tile.colorInformation}
        colorSwatchCount={colorSwatchCount}
        selectedProductVariants={tile.selectedProductVariants}
        quantity={tile.quantity}
      />
    </>
  )
}

export const renderProductDebugError = (tile: ProductTile) => {
  const { debugMode } = useAppContext()
  return tile && !tile.associatedPageAvailable && debugMode
}
